import React, { useContext } from 'react';
import { Card, Button, CircularProgress } from '@material-ui/core';
import { AuthStatusContext, retrievePlan, request, getCurrentStatus } from '@trp-individual-investor-adv-disc/adv-shared';
import { useHistory } from 'react-router-dom';
import { submitIP } from '../../HubUtils';

import './ChangeHeader.scss'

const ChangeHeader = ({ header, hasAccounts, requiresRASU, noPartnerActivateNeeded, isInternal, modelChange, hasInternalAccounts, hasExternalAccounts, hasIneligibleExternalAccounts, hasIneligibleBrokerage }) => {
    const { state, dispatch } = useContext(AuthStatusContext);
    const { applicationConfig, status } = state;
    const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [hover, setHover] = React.useState(null);
    const onEnter = () => setHover(true);
    const onLeave = () => setHover(false);

    const history = useHistory();

    const handleSubmit = () => {
        setIsSubmitLoading(true);
        if (process.env.REACT_APP_MOCK) {
            setIsSubmitLoading(false);
            history.push(requiresRASU
                ? '/personal-investing/tools/adv-nasu/legal-consent'
                : `/status${noPartnerActivateNeeded ? '?complete' : ''}`
            );
        } else if (requiresRASU) {
            // Submit IP and redirect to RASU Consent2
            submitIP(applicationConfig, '/personal-investing/tools/adv-nasu/legal-consent');
        } else {
            // Submit IP and route to status page when RASU is not needed
            request(
                applicationConfig,
                '/adv-disc-svc/service/investment-proposal/v1/activate',
                'post',
                {},
                null,
                '/usis/advice/checkout'
            )
            .then(async () => {
                // re-check status flags if there are two household members
                if (status && status.groupHasCoClient) {
                    const currentStatus = await getCurrentStatus(applicationConfig, '/usis/advice/checkout');
                    dispatch({
                        type: 'UPDATE_STATUS',
                        payload: {
                            status: currentStatus
                        }
                    });
                }
                history.push(`/status${noPartnerActivateNeeded ? '?complete' : ''}`);
                setIsSubmitLoading(false);
            });
        }
    };

    const getPlan = async () => {
        setIsLoading(true);
        await retrievePlan(applicationConfig)
            .finally(() => {
            setIsLoading(false);
        })
    };  

    return <>
        <Card className='changeHeaderContainer'>
            <div className='changeHeaderTitle'>
                {header}
            </div>
            <ul>
                {!hasIneligibleExternalAccounts && !hasIneligibleBrokerage ? <>
                    {hasAccounts ?
                        <li>
                            Select “Submit” to begin the process{modelChange ? ' to transition your advisory accounts into your new recommended portfolio' : null}
                            {modelChange && hasInternalAccounts ? ' and' : null}{hasInternalAccounts ? ' to transfer the internal accounts you selected into the Service' : null}.
                        </li>
                    : null}
                    {requiresRASU ?
                        <li>
                            Because new account types are being added to your advisory portfolio, after selecting “Submit”, you will be prompted to accept our Terms of Service and then to open the accounts. 
                        </li>
                    : null}
                    {hasExternalAccounts ?
                        <li>
                            You will be prompted to begin the process to transfer the external accounts you selected into the Service{requiresRASU ? ' once you submit the request to open your new account types' : ' after selecting “Submit”'}.
                        </li>
                    : null}
                </> : <>
                    {hasIneligibleExternalAccounts ?
                        <li>
                            Please note that one or more of your external accounts are not eligible to be transferred directly into the Service. Your advisor will work with you to bring those assets into T. Rowe Price. Then you will be able to proceed.
                        </li>
                    : null}
                    {hasIneligibleBrokerage ?
                        <li>
                            Please note that one or more of your internal brokerage accounts holds securities that are ineligible to be transferred directly into your Retirement Advisor Service accounts. Your advisor will work with you to address these securities and then you will be able to proceed.
                        </li>
                    : null}
                </>}
                <li>
                    If you have questions, please contact your advisor.
                </li>
            </ul>
            {hasAccounts && <Button variant='contained' color='primary' className='changeHeaderButton'
                onClick={() => handleSubmit()}
                disabled={isInternal || hasIneligibleExternalAccounts || hasIneligibleBrokerage || isSubmitLoading}
            >
                Submit {' '}
                {isSubmitLoading && React.cloneElement(
                    <CircularProgress
                        size={20}
                        id='loading-spinner'
                        style={{
                            color: '#05C3DE',
                            marginLeft: '16px',
                            verticalAlign: 'sub',
                            animation: 'none'
                        }}
                    /> , { filled: !!hover })}
            </Button>}
            <Button
                variant="outlined"
                color="primary"
                className='changeHeaderButton changeHeaderPlanButton'
                onClick={() => getPlan()}
                onMouseEnter={onEnter}
                onMouseLeave={onLeave}
            >
                View Updated Plan {' '}
                {isLoading && React.cloneElement(
                    <CircularProgress
                        size={20}
                        id='loading-spinner'
                        style={{
                            color: '#05C3DE',
                            marginLeft: '16px',
                            verticalAlign: 'sub',
                            animation: 'none'
                        }}
                    /> , { filled: !!hover })}
            </Button>
        </Card>
    </>
};

export default ChangeHeader;
